import { render } from "./App.vue?vue&type=template&id=6ac13754"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6ac13754&lang=scss"

import exportComponent from "/Users/shelingke/Documents/近海数据/官网/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__